import { Map } from 'ol';
import { Control } from 'ol/control';
import * as React from 'react';
import { useCallback, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

const MapBorderWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colorBorder};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.focusOutlineColor} !important; //#bfc7de
    outline-offset: 1px;
  }
  .map-widget-component-form-item.ant-form-item-has-error & {
    border-color: ${({ theme }) => theme.colorError};
  }
`;

export interface IOpenLayersMapProps {
  init: (target: HTMLDivElement, control: HTMLDivElement) => Map;
  controls?: React.ReactNode;
  style?: React.CSSProperties;
}

export function OpenLayersMap(props: IOpenLayersMapProps) {
  const { init, style } = props;
  const mapElement = useRef<HTMLDivElement | null>(null);
  const mapRef = useRef<Map | null>(null);
  const controlsElement = useRef<HTMLDivElement>(document.createElement('div'));

  const initMap = useCallback(
    (element: HTMLDivElement | null) => {
      // console.log(`[OpenLayersMap] initMap`, element);
      mapElement.current = element;
      if (element == null) {
        return;
      }

      // Sostituisco il div sottostante la mappa con quello aggiornato.
      if (mapRef.current != null) {
        mapRef.current.setTarget(element);
        return;
      }

      const customControl = new Control({
        element: controlsElement.current,
      });

      const map = init(element, controlsElement.current);
      map.addControl(customControl);
      mapRef.current = map;
    },
    [init],
  );

  const controlsPortal = ReactDOM.createPortal(
    props.controls,
    controlsElement.current,
  );

  return (
    <>
      <MapBorderWrapper
        ref={divElement => initMap(divElement)}
        role="application"
        aria-label="Mappa"
        tabIndex={0} // NOSONAR: Permette di dare il focus al div, in modo da poterlo scorrere con la tastiera. ([a11y])
        style={{ height: '600px', width: '100%', ...style }}
      />
      {controlsPortal}
    </>
  );
}
